<template>
  <div>
    <h1>Survey Questions</h1>
    <div>
      <div>
        <button
          style="border-radius:20px;"
          class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-4 hover:bg-green-900"
          @click="createSurveyQuestion"
        >
          Create Survey Question
        </button>
      </div>
      <div class="row">
        <div class="small-12 columns" style="background-color:blue;">
          <table style="width:100%;">
            <thead>
              <tr>
                <th>ID</th>
                <th>TITLE</th>
                <th>CONTENT</th>
                <th>OPTION</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(x, i) in surveyQuestions" :key="i">
                <td>{{ x.id }}</td>
                <td>{{ x.title }}</td>
                <td>{{ x.content }}</td>
                <td>
                  <router-link
                    class="link"
                    style="color: white"
                    :to="getEditSurveyQuestion(x)"
                    >EDIT</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      surveyQuestions: [],
    }
  },
  created() {
    this.SurveyQuestionsList()
  },
  methods: {
    SurveyQuestionsList() {
      const loader = this.$loading.show()
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}survey/questions`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          loader.hide()
          this.surveyQuestions = res.data.survey_questions
        })
        .catch(err => {
          loader.hide()
          this.$noty.error(`Failed to get the the survey questions ${err}`)
        })
    },
    createSurveyQuestion() {
      this.$router.push({ name: "AddSurveyQuestion" })
    },
    getEditSurveyQuestion(question) {
      return { name: "EditSurveyQuestion", params: { id: question.id } }
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
